import React, { type ReactNode } from 'react';

import CloseIcon from '@pkg/assets/icons/v2/close.svg?react';
import { CircleButton } from '@pkg/components';
import { useBreakpoints } from '@pkg/hooks';

import { cardMotion, wrapperMotion } from './InfoModal.motion';

import { Backdrop, Banner, Card, CloseButtonWrapper, Content, Wrapper } from './InfoModal.style';

export interface InfoModalProps {
    bannerContent?: ReactNode;
    bodyContent?: ReactNode;
    onClose: () => void;
}

export function InfoModal({ bannerContent, bodyContent, onClose }: InfoModalProps) {
    const { isMobile } = useBreakpoints();

    return (
        <Wrapper {...wrapperMotion}>
            <Card {...cardMotion}>
                <Banner>
                    <CloseButtonWrapper>
                        <CircleButton
                            variant="solid"
                            size={isMobile ? 'small' : 'medium'}
                            ariaLabel={'Close modal'}
                            onClick={onClose}
                        >
                            <CloseIcon aria-hidden="true" />
                        </CircleButton>
                    </CloseButtonWrapper>

                    {bannerContent}
                </Banner>

                <Content>{bodyContent}</Content>
            </Card>

            <Backdrop onClick={onClose} />
        </Wrapper>
    );
}
